import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Activity(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M9 2a1 1 0 0 1 .95.68L15 17.84l2.05-6.16A1 1 0 0 1 18 11h4a1 1 0 1 1 0 2h-3.28l-2.77 8.32a1 1 0 0 1-1.9 0L9 6.16l-2.05 6.16A1 1 0 0 1 6 13H2a1 1 0 1 1 0-2h3.28l2.77-8.32A1 1 0 0 1 9 2Z" }) }));
}
